"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _polished = require("polished");

var _reactRouterDom = require("react-router-dom");

var _uberSvgIcons = require("./uberSvgIcons");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["items", "position", "navbarWidth"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledNav = _styledComponents.default.nav(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: ", ";\n  z-index: ", ";\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  display: flex;\n  align-items: space-between;\n  justify-content: space-between;\n  pointer-events: none;\n  background: ", ";\n\n  @media (min-width: ", ") {\n    left: 50%;\n    width: ", ";\n    margin: 0 auto;\n    transform: translateX(-50%);\n  }\n"])), function (p) {
  return p.position || "fixed";
}, function (p) {
  return p.theme.zIndexNavbar || 2;
}, function (p) {
  return p.theme.colorAccent;
}, function (props) {
  return props.theme.screenWidthMd;
}, function (props) {
  return props.navbarWidth;
});

var sharedLinkCss = (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n  flex: 1 1 50%;\n  display: flex;\n  height: 80px;\n  padding-top: 12px;\n  align-items: center;\n  justify-content: flex-start;\n  flex-direction: column;\n  text-align: center;\n  transition: transform 0.25s;\n  pointer-events: all;\n  text-decoration: none;\n  color: ", ";\n\n  & path {\n    fill: ", ";\n  }\n"])), (0, _polished.rgba)("black", 0.25), (0, _polished.rgba)("black", 0.25));
var StyledNavLink = (0, _styledComponents.default)(_reactRouterDom.NavLink)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", ";\n\n  &.active {\n    color: ", ";\n  }\n\n  &.active path {\n    fill: ", ";\n  }\n"])), sharedLinkCss, function (p) {
  return p.theme.colorAccentText;
}, function (p) {
  return p.theme.colorAccentText;
});

var StyledDisabledLink = _styledComponents.default.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", ";\n  cursor: not-allowed;\n  color: ", ";\n"])), sharedLinkCss, (0, _polished.rgba)("black", 0.15));

var StyledNavLinkIcon = _styledComponents.default.span(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  margin-bottom: 0.325rem;\n"])));

var StyledNavLinkText = _styledComponents.default.span(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  font-size: 0.675rem;\n  font-family: ", ";\n"])), function (p) {
  return p.theme.fontFamilyDefault;
});

var icons = [_uberSvgIcons.ScoresIcon, _uberSvgIcons.LeaderboardIcon, _uberSvgIcons.WalletIcon, _uberSvgIcons.ProfileIcon];

var NavbarSimple = function NavbarSimple(_ref) {
  var items = _ref.items,
      position = _ref.position,
      navbarWidth = _ref.navbarWidth,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledNav, _objectSpread(_objectSpread({
    position: position,
    navbarWidth: navbarWidth
  }, rest), {}, {
    children: items.map(function (item, index) {
      return item.disabled ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledDisabledLink, {
        children: [/*#__PURE__*/_react.default.createElement(icons[index]), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledNavLinkText, {
          children: item.text
        })]
      }, item.name) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledNavLink, {
        to: item.to,
        children: [/*#__PURE__*/_react.default.createElement(icons[index]), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledNavLinkText, {
          children: item.text
        })]
      }, item.name);
    })
  }));
};

var _default = NavbarSimple;
exports.default = _default;